module.exports = __webpack_public_path__ + "img/horizontal_6_1_0.f60290e1.png";